<div class="mat-dialog-container">
  <!-- 明細編輯開始 -->
  <div #head>
    <app-modal-header #modal_header [isDialog]="isDialog" [title]="title" [state]="srv.state" (onOkClick)="doOk($event)"
      (onCancelClick)="doCancel($event)">
    </app-modal-header>
  </div>
  <div class="jk-content">
    <div class="jk-grid-cols-4"> 
    <app-jktext  label="序號" [value]="item.WL002"     >
    </app-jktext>
    <app-jknumberedit  label="排序碼" #WL003Com  id="WL003"  [(value)]="item.WL003" placeholder="排序碼"  [readonly]="isBrowse"     >
    </app-jknumberedit>
    <app-jktextarea  height="250px" 
 label="html內文" #WL004Com  id="WL004"  [(value)]="item.WL004" placeholder="html內文"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jkdatefield  label="日期" #WL005Com  id="WL005"  [(value)]="item.WL005" placeholder="日期"  [readonly]="isBrowse" 
            >
    </app-jkdatefield>
    <app-jkdatefield  label="Date" #WL006Com  id="WL006"  [(date)]="item.WL006" placeholder="Date"  [readonly]="isBrowse" 
            >
    </app-jkdatefield>
    <app-jktextarea  height="250px" 
 label="主旨" #WL007Com  id="WL007"  [(value)]="item.WL007" placeholder="主旨"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jkcheckboxYN  label="星號" #WL008Com  id="WL008"  [(valueYN)]="item.WL008"  [readonly]="isBrowse"     >
    </app-jkcheckboxYN>
    <app-jktext  label="來源單號" [value]="item.WL009"     >
    </app-jktext>
    <app-jkedit  label="股票代號" #WL010Com  id="WL010"  [(value)]="item.WL010" placeholder="股票代號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkcheckboxYN  label="tag" #WL011Com  id="WL011"  [(valueYN)]="item.WL011"  [readonly]="isBrowse"     >
    </app-jkcheckboxYN>
    <app-jkedit  label="格式" #WL012Com  id="WL012"  [(value)]="item.WL012" placeholder="格式"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jktextarea  height="250px" 
 label="html內文" #WL013Com  id="WL013"  [(value)]="item.WL013" placeholder="html內文"  [readonly]="isBrowse"     >
    </app-jktextarea>
    <app-jkcombobox label="大分類" #WL014Com id="WL014" [(value)]="item.WL014" [items]="srv.mtrWd015List"
      [readonly]="isBrowse">
    </app-jkcombobox>

    </div>
  </div>
</div>
